<div class="dialog">
  <div class="dialog-header">
    <span class="dialog-title">Add user</span>
    <button type="button" class="close-btn" [disabled]="isLoading" (click)="close()" aria-label="Close">×</button>
  </div>

  <form [formGroup]="form" class="dialog-form">
    <div class="field-row">
      <div class="field">
        <span class="field-label">Username</span>
        <input class="text-box-active" formControlName="userName" />
        @if(usernameCheck.message){
        <span
          class="field-message"
          [class.field-error]="usernameCheck.status === 'taken' || usernameCheck.status === 'short'"
          [class.field-success]="usernameCheck.status === 'available'"
        >
          {{ usernameCheck.message }}
        </span>
        }
      </div>
      <div class="field">
        <span class="field-label">Family code</span>
        <input
          class="text-box-active"
          formControlName="familyCode"
          inputmode="numeric"
          maxlength="12"
          (input)="onFamilyCodeInput()"
        />
        @if(memberLookup.isLoading){ <span class="field-message">Finding members…</span> }
      </div>
    </div>
    <div class="field-row">
      <div class="field">
        <span class="field-label">Name</span>
        <mat-form-field class="ac-select-field" appearance="outline" subscriptSizing="dynamic">
          <mat-select
            panelClass="ac-select-panel"
            [disableOptionCentering]="true"
            formControlName="memUuid"
            [placeholder]="memberLookup.loaded ? 'Select the person' : 'Enter the family code first'"
            (selectionChange)="onMemberPick($event.value)"
          >
            @for(m of memberLookup.members; track $index){
            <mat-option [value]="m.memUuid" [disabled]="!m.memUuid">
              {{ m.fullName }}
            </mat-option>
            } @empty {
            <mat-option [value]="''" disabled>
              {{ memberLookup.loaded ? 'No members found.' : 'Enter the 12-digit family code.' }}
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
        @if(memberLookup.pickMessage){
        <span class="field-message" [class.field-error]="memberLookup.pickStatus === 'taken'">
          {{ memberLookup.pickMessage }}
        </span>
        }
      </div>
      <div class="field">
        <span class="field-label">Role</span>
        <mat-form-field class="ac-select-field" appearance="outline" subscriptSizing="dynamic">
          <mat-select panelClass="ac-select-panel" [disableOptionCentering]="true" formControlName="roleKey">
            @for(r of roles; track r.roleId){ <mat-option [value]="r.roleKey">{{ r.roleName }}</mat-option> }
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    @if(isVolunteer){
    <div class="field-row">
      <div class="field">
        <label class="field-label" for="sa-user-valid-until">Access valid until <span aria-hidden="true">*</span></label>
        <input id="sa-user-valid-until" type="date" class="text-box-active" formControlName="validUntil" />
      </div>
    </div>
    }
    <div class="field-row">
      <div class="field">
        <span class="field-label">Branch (for branch roles)</span>
        <mat-form-field class="ac-select-field" appearance="outline" subscriptSizing="dynamic">
          <mat-select panelClass="ac-select-panel" [disableOptionCentering]="true" formControlName="establishmentId">
            <mat-option [value]="null">None (central)</mat-option>
            @for(e of establishments; track e.establishmentId){ <mat-option [value]="e.establishmentId">{{ e.name }}</mat-option> }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="field"><span class="field-label">Mobile number</span><input class="text-box-active" formControlName="mobileNumber" /></div>
    </div>
    <div class="field-row">
      <div class="field"><span class="field-label">Email</span><input class="text-box-active" formControlName="emailId" /></div>
      <div class="field"><span class="field-label">Identity number</span><input class="text-box-active" formControlName="identityNumber" /></div>
    </div>
  </form>

  <div class="dialog-actions">
    <button type="button" class="ac-secondary-btn" (click)="close()">Close</button>
    <button type="button" class="ac-primary-btn" (click)="submit()">Add</button>
  </div>
</div>

<app-loader [isLoading]="isLoading"></app-loader>
